// "Often Chosen Together" needs to sit in two different places depending on viewport: stacked below
// the gallery on desktop (the theme's native "show_below_gallery" placement, left column), but right
// after the Buy Now button on mobile (single column, so "below gallery" there actually means "after
// everything, at the very bottom" — not what's wanted). One Liquid setting can't render two different
// positions, so this keeps the block in its native below-gallery position and relocates it via JS only
// on mobile, moving it back if the viewport grows back to desktop width.
//
// Also strips a trailing " | <Month> Birthstone"-style suffix from card titles in this carousel only,
// so cards stay concise — the full product name still shows on that product's own page, this only
// affects how it's displayed here.
//
// This is scoped via the carousel element IDs rather than a data-block-id wrapper, because the
// below-gallery render path (sections/main-product.liquid) doesn't add that wrapper — only the inline
// render path (snippets/product-info.liquid) does. The carousel IDs are stable either way: Shopify
// builds them from this block's own id ("complementary_products_pdp0408"), so matching on that
// substring works regardless of which of the two paths actually rendered it.
//
// Navigation replaces the dot pagination with the same sliding progress-bar style already used under
// the product gallery (see snippets/product-gallery.liquid + assets/gallery-progress-bar.js) — reusing
// its exact class names and fill/thumb math for visual consistency, rather than inventing a new style.
// It can't reuse that script directly though: it only runs once on DOMContentLoaded and finds bars by
// walking to `previousElementSibling`, but this carousel's content (and this bar) render in asynchronously
// well after that, and the bar needs to sit below the card row rather than next to the dots it replaces.
// An earlier attempt at custom prev/next arrows here produced inconsistent behavior (one arrow rendering
// without its pair) that couldn't be reliably diagnosed without live DOM access — this sidesteps that
// entirely by reusing a component that's already proven to work correctly elsewhere on this page.
(function () {
  var BLOCK_ID = 'complementary_products_pdp0408';
  var DESKTOP_BREAKPOINT = 1000; // matches sections/main-product.liquid's own gallery/info grid breakpoint
  var BIRTHSTONE_SUFFIX = /\s*\|\s*[A-Za-z]+\s+Birthstone\s*$/i;
  var found = false;
  var container = null;
  var originalParent = null;
  var originalNextSibling = null;
  var relocated = false;

  function buildProgressBar(carousel, extraClass) {
    var bar = document.createElement('div');
    bar.className = 'gallery-progress-bar pdp-complementary-progress-bar ' + extraClass;
    bar.setAttribute('aria-hidden', 'true');

    var fill = document.createElement('div');
    fill.className = 'gallery-progress-bar__fill';
    bar.appendChild(fill);

    function update() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      var thumbWidth = maxScroll > 0 ? (carousel.clientWidth / carousel.scrollWidth) * 100 : 100;
      thumbWidth = Math.max(8, Math.min(100, thumbWidth));

      var scrollPercent = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 0;
      var left = scrollPercent * (100 - thumbWidth);

      fill.style.width = thumbWidth + '%';
      fill.style.left = left + '%';
    }

    carousel.addEventListener('scroll', update, { passive: true });
    update();

    return bar;
  }

  function stripBirthstoneSuffixes() {
    var titles = container.querySelectorAll('.product-title');

    for (var i = 0; i < titles.length; i++) {
      var el = titles[i];
      var current = el.textContent;
      var stripped = current.replace(BIRTHSTONE_SUFFIX, '');

      if (stripped !== current) {
        el.textContent = stripped;
      }
    }
  }

  function tryFind() {
    if (found) {
      return;
    }

    var anyCarousel = document.querySelector('scroll-carousel[id*="' + BLOCK_ID + '"]');

    if (!anyCarousel) {
      return;
    }

    container = anyCarousel.closest('.complementary-products');

    if (!container) {
      return;
    }

    var mobileCarousel = container.querySelector('[id^="complementary-products-mobile-carousel-"]');
    var desktopCarousel = container.querySelector('[id^="complementary-products-carousel-"]');

    if (!mobileCarousel || !desktopCarousel) {
      return;
    }

    mobileCarousel.insertAdjacentElement('afterend', buildProgressBar(mobileCarousel, 'pdp-complementary-progress-bar--mobile'));
    desktopCarousel.insertAdjacentElement('afterend', buildProgressBar(desktopCarousel, 'pdp-complementary-progress-bar--desktop'));

    container.classList.add('pdp-complementary-marker');
    stripBirthstoneSuffixes();

    originalParent = container.parentElement;
    originalNextSibling = container.nextSibling;

    found = true;
    updatePosition();
  }

  function updatePosition() {
    if (!found) {
      return;
    }

    var isMobile = window.innerWidth < DESKTOP_BREAKPOINT;

    if (isMobile && !relocated) {
      var buyButtons = document.querySelector('[data-block-id="buy_buttons"]');

      if (buyButtons && buyButtons.parentElement) {
        buyButtons.insertAdjacentElement('afterend', container);
        relocated = true;
      }
    } else if (!isMobile && relocated) {
      if (originalNextSibling) {
        originalParent.insertBefore(container, originalNextSibling);
      } else {
        originalParent.appendChild(container);
      }
      relocated = false;
    }
  }

  tryFind();

  var observer = new MutationObserver(function () {
    tryFind();

    // New cards can render into the carousel slightly after it's first found (async recommendations),
    // so keep stripping suffixes on later mutations too, not just the first pass.
    if (found) {
      stripBirthstoneSuffixes();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, 15000);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updatePosition, 150);
  });
})();
